module.exports = __webpack_public_path__ + "52d93ad63739ee7a70909b8a344971f6.svg";


//////////////////
// WEBPACK FOOTER
// ./components/applications/apply/r-name-icon.svg
// module id = 1057
// module chunks = 0